// Function to format ID
const format4Digit = (id) => {
    // Convert to string and check length
    const strId = id.toString();

    // If length is 5 or more, return original
    if (strId.length >= 5) {
        return strId;
    }

    // Pad with zeros to 4 digits
    return strId.padStart(4, '0');
};

const NumberFormatHelper = {
    format4Digit,
};

export default NumberFormatHelper;
